<template>
	<v-data-table
		:headers="headers"
		:items="rows"
		:options="options"
		:server-items-length="total"
		:loading="loading"
		item-key="_key"
		:mobile-breakpoint="0"
		class="elevation-0 tabella-analisi"
		:footer-props="{ 'items-per-page-options': [25, 50, 100] }"
		@update:options="$emit('update:options', $event)"
	>
		<template v-slot:item="{ item }">
			<tr>
				<td class="py-1">
					<div class="d-flex align-center prodotto">
						<v-img v-if="item.image" :src="item.image" max-width="48" max-height="48" contain class="mr-2 flex-grow-0"></v-img>
						<v-icon v-else color="grey lighten-1" class="mr-2">mdi-image-off-outline</v-icon>
						<div>
							<div>{{ item.name || '—' }}</div>
							<div class="caption grey--text">{{ item.sku || item.variantSku || '' }}</div>
						</div>
					</div>
				</td>
				<td class="text-right text-no-wrap font-weight-bold">
					{{ money(item.price) }}
					<div v-if="item.lastApplyAt" class="caption grey--text font-weight-regular">applicato il {{ item.lastApplyAt | moment('DD/MM HH:mm') }}</div>
				</td>
				<td v-for="s in sites" :key="s._id" class="text-right text-no-wrap" :class="classeCella(item, s._id)">
					<template v-if="competitor(item, s._id)">
						<a v-if="competitor(item, s._id).url" :href="competitor(item, s._id).url" target="_blank" rel="noopener noreferrer" :class="classeTesto(item, s._id)">
							{{ money(competitor(item, s._id).price, competitor(item, s._id).currency) }}
						</a>
						<span v-else :class="classeTesto(item, s._id)">{{ money(competitor(item, s._id).price, competitor(item, s._id).currency) }}</span>
						<div class="caption grey--text">{{ metodo(competitor(item, s._id).method) }}</div>
					</template>
					<span v-else class="grey--text">—</span>
				</td>
				<td class="text-no-wrap">
					<div class="d-flex align-center">
						<template v-if="direzione(item) === 'down'">
							<v-icon color="red" small class="mr-1">mdi-arrow-down-bold</v-icon>
							<span class="red--text">Abbassa a {{ money(item.suggested) }}</span>
						</template>
						<template v-else-if="direzione(item) === 'up'">
							<v-icon color="green" small class="mr-1">mdi-arrow-up-bold</v-icon>
							<span class="green--text text--darken-2">Aumenta a {{ money(item.suggested) }}</span>
						</template>
						<span v-else class="grey--text">—</span>
						<v-spacer></v-spacer>
						<v-btn small text color="primary" class="ml-2" :disabled="!item.item" @click="$emit('apply', item)">
							<v-icon left small>mdi-tune-variant</v-icon>
							Applica prezzo
						</v-btn>
					</div>
				</td>
			</tr>
		</template>
	</v-data-table>
</template>

<script>
import { cellStatus, suggestionDirection, money } from '../../views/competitor/pricing';
import { METODI_MATCH } from './testi';

// Tabella di Analisi Competitor: solo presentazione, le azioni salgono al contenitore.
export default {
	name: 'CompetitorAnalysisTable',
	props: {
		rows: { type: Array, default: () => [] },
		sites: { type: Array, default: () => [] },
		total: { type: Number, default: 0 },
		options: { type: Object, required: true },
		loading: { type: Boolean, default: false },
	},
	computed: {
		headers() {
			return [
				{ text: 'Prodotto', value: 'name', sortable: false },
				{ text: 'Nostro prezzo', value: 'price', sortable: false, align: 'end' },
				...this.sites.map(s => ({ text: s.name, value: `site_${s._id}`, sortable: false, align: 'end' })),
				{ text: 'Suggerimento', value: 'suggested', sortable: false },
			];
		},
	},
	methods: {
		money,
		competitor(row, siteId) {
			const c = row.competitors && row.competitors[siteId];
			return c && c.price !== null && c.price !== undefined ? c : null;
		},
		stato(row, siteId) {
			const c = this.competitor(row, siteId);
			return c ? cellStatus(row.price, c.price) : null;
		},
		// verde = siamo piu' economici, rosso = siamo piu' cari
		classeCella(row, siteId) {
			const s = this.stato(row, siteId);
			if (s === 'better') return 'green lighten-5';
			if (s === 'worse') return 'red lighten-5';
			return '';
		},
		classeTesto(row, siteId) {
			const s = this.stato(row, siteId);
			if (s === 'better') return 'green--text text--darken-2 font-weight-bold';
			if (s === 'worse') return 'red--text text--darken-1 font-weight-bold';
			return '';
		},
		direzione(row) {
			return suggestionDirection(row.price, row.suggested);
		},
		metodo(m) {
			return m ? `abbinato per ${(METODI_MATCH[m] || { testo: m }).testo}` : '';
		},
	},
};
</script>

<style scoped>
.prodotto {
	min-width: 220px;
}
</style>
